import { AlertCircleIcon } from '@orn/shared-web/icons';

import PlaidLinkButton from '../plaid/PlaidLinkButton';

interface IReplaceConnectionButtonProps {
  /** The account the refusal was raised for; the fresh link replaces its connection. */
  account: { bankConnectionId: string; bankName: string };
  /** Re-reads the household once a session linked or replaced a bank, whichever bank it was. */
  onRefetch: () => void;
  /** Clears the refusal the button answered, only once the connection was replaced. */
  onReplaced: () => void;
}

/**
 * Reconnects the bank behind an account that could not be tokenized for a
 * debit, through a fresh link that replaces the connection in place: the
 * accounts keep their history and the new link asks the bank for the
 * permission a debit needs.
 *
 * One possible remedy, not a diagnosis: the provider's refusal does not say
 * whether that permission is withheld or the account cannot be debited at
 * all, so the copy beside this offers choosing another account too. A session
 * that linked some other bank instead leaves the refusal standing.
 */
const ReplaceConnectionButton = ({ account, onRefetch, onReplaced }: IReplaceConnectionButtonProps) => (
  <PlaidLinkButton
    // The treatment `PlaidFixConnectionButton` gives a Plaid recovery action,
    // which is what this is — the palette names the problem, not the verb.
    color="primary-destructive"
    iconLeading={AlertCircleIcon}
    replacesBankConnectionId={account.bankConnectionId}
    onSuccess={(_linkedAccounts, { isReconnection }) => {
      onRefetch();
      if (isReconnection) {
        onReplaced();
      }
    }}
  >
    Reconnect {account.bankName}
  </PlaidLinkButton>
);

ReplaceConnectionButton.displayName = 'ReplaceConnectionButton';

export default ReplaceConnectionButton;
